/**
 * 缓存键名配置
 */
export const SKEY_TOKEN = 'x-auth-token'

export const SKEY_USERINFO = 'userinfo'



// WEBPACK FOOTER //
// ./src/config/storage.config.js